<template lang='pug'>
  #GPT.main-page.GPT-color.page-noScroll.pb-0.position-relative
    loadingOverlay(v-if='loading' message='Loading . . .' :zIndex='999' attach)
    loadingOverlay(v-if='delLoading' message='Loading . . .' :zIndex='999' attach)
            v-progress-circular(indeterminate color='primary')
    div.height_100(v-if='!loading')
      div(:href='"/upgpt/Chatbot"').d-flex.align-start.justify-start.pl-9
        v-breadcrumbs.pa-0.px-3.pb-2.ellipsis()
          v-breadcrumbs-item(v-for="item in breadcrumbs" :key="item.text" )
            .detail_a
              a(:href='item.href')
                v-icon(size='23' style='margin-bottom:2px;').pr-1 mdi-chevron-double-left
                span {{item.text}}
      #page-inner.pa-3.d-flex.align-center.justify-center.pl-13(style='width:97%;')
        v-row.align-stretch(no-gutters='no-gutters'  justify="end")
            //-  在channel是 UpSide 時顯示
            v-col.pr-0(v-if="aibotData.channel == 'UpSide'" cols='6')
              v-card.deal-tab-card.rounded-card(style='width:98.5%;' flat min-height='300px')
                v-row(no-gutters='no-gutters' align="center" justify="start")
                  v-col(cols='12' md='12')
                      .pt-6.pb-3
                        v-card-text.mt-0.pa-0
                          h4.f-text-highlight-word.ml-6 {{$t("ADD_AIBOTS.DETAIL")}}
                          v-row.pl-3
                            v-col(cols='3').pr-0.pl-0                            
                              .d-flex.align-start.justify-center.bot-icon.pt-2
                                div.d-flex.justify-center.align-center
                                  v-img(src="../assets/images/ann.png"   max-width="100px")
                            v-col(cols='9')
                              .scrollbar.MeetingRecapMinH_ChatBot  
                                v-form.pt-0.mt-6(v-model='valid' ref='formContact')
                                  v-row(no-gutters)
                                    v-col.pr-md-4(cols='12' md='12').my-1.mb-1
                                      p.d-flex.align-center.input-has-label.input-has-label-no-border.position-relative
                                        label.pt-3
                                          h6.t-black {{$t('ADD_AIBOTS.NAME')}} :
                                        v-text-field.v-text-field_low_z-index(solo falt dense v-model='aibotData.bot_name' :readonly='!isEdit' ref='firstTextField' :rules="formRule.rules100" style='padding-top:0.1rem;') 
                                    v-col.pr-md-4(cols='12' md='12').mb-1            
                                      p.d-flex.align-center.input-has-label.input-has-label-no-border
                                          label.pt-2
                                            h6.t-black {{$t('GPT_AIBOTS.REPLY_LANGUAGE')}} :
                                          v-select.no-border( solo flat
                                          v-model='aibotData.answer_language'
                                          :items='removeAutoAssistantLanguageList' 
                                          item-text='name' 
                                          item-value='key'
                                          :readonly='!isEdit'
                                          :class='!isEdit ? "remove-arrow" : ""'
                                          )
                                            template(v-slot:append-outer)
                                              v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                              v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                              v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                              v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                    v-col.pr-md-4(cols='12' md='12')
                                      p.d-flex.align-center.input-has-label.input-has-label-no-border
                                          label.pt-2
                                            h6.t-black {{$t('GPT_AIBOTS.MODEL')}} :
                                          v-select.no-border( solo flat 
                                          v-model='aibotData.deployment_name'
                                          :items='model_list_for_upside' 
                                          item-text='name' 
                                          item-value='id' 
                                          :readonly='!isEdit' 
                                          :class='!isEdit ? "remove-arrow" : ""')
                                            template(v-slot:append-outer)
                                              v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                              v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                              v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                              v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                    //- //- GPT5 VERBOSITY
                                    //- v-col.pr-md-4(cols='12' md='12' v-if="aibotData.deployment_name.includes('gpt5')")
                                    //-   p.d-flex.align-center.input-has-label.input-has-label-no-border
                                    //-       label.pt-2
                                    //-         h6.t-black {{$t('GPT_AIBOTS.VERBOSITY')}} :
                                    //-       v-select.no-border( solo flat 
                                    //-       v-model='model_parameter.verbosity'
                                    //-       :items='verbosity_list' 
                                    //-       item-text='name' 
                                    //-       item-value='id' 
                                    //-       :readonly='!isEdit' 
                                    //-       :class='!isEdit ? "remove-arrow" : ""')
                                    //-         template(v-slot:append-outer)
                                    //-           v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                    //-           v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                    //-           v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                    //-           v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                    //- v-col.pr-md-4(cols='12' md='12' v-if="aibotData.deployment_name.includes('gpt5')")
                                    //-   p.d-flex.align-center.input-has-label.input-has-label-no-border
                                    //-       label.pt-2
                                    //-         h6.t-black {{$t('GPT_AIBOTS.REASONING_EFFORT')}} :
                                    //-       v-select.no-border( solo flat 
                                    //-       v-model='model_parameter.effort'
                                    //-       :items='reasoning_list' 
                                    //-       item-text='name' 
                                    //-       item-value='id' 
                                    //-       :readonly='!isEdit' 
                                    //-       :class='!isEdit ? "remove-arrow" : ""')
                                    //-         template(v-slot:append-outer)
                                    //-           v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                    //-           v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                    //-           v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                    //-           v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
            //-  在channel是 UpGPT_Portal Teams 時顯示
            v-col.pr-0(v-else-if="(((gpt5_channel.includes(aibotData.channel))) && !(tenant_name == 'libo' && aibotData.channel == 'teams'))" cols='6')
              v-card.deal-tab-card.rounded-card(style='width:98.5%;' flat min-height='300px')
                v-row(no-gutters='no-gutters' align="center" justify="start")
                  v-col(cols='12' md='12')
                      .pt-6.pb-3
                        v-card-text.mt-0.pa-0
                          h4.f-text-highlight-word.ml-6 {{$t("ADD_AIBOTS.DETAIL")}}
                          v-row.pl-3
                            v-col(cols='3' v-if="aibotData.channel == 'UpGPT_Portal'" ).pa-0
                              // 舊的使用LOGO-icon
                              //- .d-flex.align-start.justify-center.bot-icon.pt-2
                              //-   div.d-flex.justify-center.align-center
                              //-     v-img(src="../assets/images/Logo_svg.svg"  max-width="75px")
                              // 新的要可以上傳公司照片
                              div.ml-0.text-center(style='min-width:200px;')
                                v-hover
                                  template(v-slot:default="{ hover }")
                                    v-list-item-avatar.ml-2.mt-12.md-0.d-flex.align-center.company_logo_container()
                                      v-icon.mx-auto.company_logo_inner(v-if="isCompany_Logo_Photo === false") Company LOGO
                                      v-img.ma-0.pa-0(v-else :src='company_logo_photo' alt='Company LOGO' max-width="160" max-height="50" style="height=50px !important; wetght=8.5vw !important;")
                                      v-fade-transition.d-flex.align-center.justify-center
                                        v-overlay.d-flex.align-center.justify-center(v-if="hover" absolute color='black' style="cursor: pointer;")
                                          v-file-input.no-border(v-show="false" v-model="company_logo_image" ref="uploader" @change="uploadimage" accept="image/*")
                                          v-icon(@click="changephoto" size='20' ) mdi-camera
                              div.ml-2.best-size-hint {{$t("ADD_AIBOTS.BEST_SIZE")}}
                            v-col(cols='3' v-else).pr-0.pl-0
                              // Teams 使用LOGO-icon
                              .d-flex.align-start.justify-center.bot-icon.pt-2
                              div(style='border: #14c6de solid 5px;border-radius:50%;min-width:120px;height:120px;').d-flex.justify-center.align-center
                                  v-img(src="../assets/images/botsetting.png"   max-width="85px")
                            v-col(cols='9')
                              .scrollbar.MeetingRecapMinH_ChatBot  
                                v-form.pt-0.mt-0(v-model='valid' ref='formContact')
                                  v-row(no-gutters)
                                    v-col.pr-md-4(cols='12' md='12').my-1.mb-1
                                      p.d-flex.align-center.input-has-label.input-has-label-no-border.position-relative
                                        label.pt-3
                                          h6.t-black {{$t('ADD_AIBOTS.NAME')}} :
                                        v-text-field.v-text-field_low_z-index(solo falt dense v-model='aibotData.bot_name' :readonly='!isEdit' ref='firstTextField' :rules="formRule.rules100" style='padding-top:0.1rem;') 
                                            template(v-slot:append)
                                                v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                                v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                                v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                                v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit    
                                    v-col.pr-md-4(cols='12' md='12' v-if="aibotData.channel =='teams' ").mb-3
                                      p.d-flex.align-center.input-has-label.input-has-label-no-border
                                        label.pt-3
                                          h6.t-black {{$t('ADD_AIBOTS.INBOX')}} :
                                        v-autocomplete(
                                            solo flat dense
                                            v-model='select_inbox'
                                            :rules='formRule.nameRules',
                                            :items='inbox_list'
                                            item-text='name'
                                            item-value='id'
                                            return-object
                                            :menu-props='{closeOnClick:true}'
                                            :readonly='!isEdit'
                                            style='padding-top:0.1rem;'
                                            :class='!isEdit ? "remove-arrow" : ""'
                                          )
                                            template(v-slot:selection="data")
                                                .d-flex.justify-space-between
                                                  v-img(v-if='data.item.channel == "teams"' src='@/assets/images/teams_logo.png' width='25px')
                                                  v-icon(v-else :color='get_upchat_channel_icon(data.item.channel).color') {{get_upchat_channel_icon(data.item.channel).icon}}
                                                  v-list-item-title.pl-1.pt-1(v-html="data.item.name")
                                            template(v-slot:item="data")
                                              v-img(v-if='data.item.channel == "teams"' src='@/assets/images/teams_logo.png' width='25px')
                                              v-icon(v-else :color='get_upchat_channel_icon(data.item.channel).color') {{get_upchat_channel_icon(data.item.channel).icon}}
                                              v-list-item-title.pl-4(v-html="data.item.name")
                                            template(v-slot:append-outer)
                                                v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                                v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                                v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                                v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                    v-col.pr-md-4(cols='12' md='12').mb-1            
                                      p.d-flex.align-center.input-has-label.input-has-label-no-border
                                          label.pt-2
                                            h6.t-black {{$t('GPT_AIBOTS.REPLY_LANGUAGE')}} :
                                          v-select.no-border( solo flat dense
                                          v-model='aibotData.answer_language'
                                          :items='assistant_language_list' 
                                          item-text='name' 
                                          item-value='key'
                                          :readonly='!isEdit'
                                          :class='!isEdit ? "remove-arrow" : ""'
                                          )
                                            template(v-slot:append-outer)
                                              v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                              v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                              v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                              v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                    v-col.pr-md-4(cols='12' md='12').mb-1            
                                      p.d-flex.align-center.input-has-label.input-has-label-no-border
                                          label.pt-2
                                            h6.t-black {{$t('GPT_AIBOTS.MODEL')}} :
                                          v-select.no-border( solo flat dense 
                                          v-model='aibotData.deployment_name'
                                          :items='model_list' 
                                          item-text='name' 
                                          item-value='id' 
                                          :readonly='!isEdit' 
                                          :class='!isEdit ? "remove-arrow" : ""')
                                            template(v-slot:append-outer)
                                              v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                              v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                              v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                              v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                    //- GPT5 VERBOSITY
                                    v-col.pr-md-4.mb-1(cols='12' md='12' v-if="aibotData.deployment_name.includes('gpt5')")
                                      p.d-flex.align-center.input-has-label.input-has-label-no-border
                                          label.pt-2
                                            h6.t-black {{$t('GPT_AIBOTS.VERBOSITY')}} :
                                          v-select.no-border( solo flat 
                                          v-model='model_parameter.verbosity'
                                          :items='verbosity_list' 
                                          item-text='name' 
                                          item-value='id' 
                                          :readonly='!isEdit' 
                                          :class='!isEdit ? "remove-arrow" : ""')
                                            template(v-slot:append-outer)
                                              v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                              v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                              v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                              v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                    //- REASONING EFFORT
                                    v-col.pr-md-4(cols='12' md='12' v-if="aibotData.deployment_name.includes('gpt5')")
                                      p.d-flex.align-center.input-has-label.input-has-label-no-border
                                          label.pt-2
                                            h6.t-black {{$t('GPT_AIBOTS.REASONING_EFFORT')}} :
                                          v-select.no-border( solo flat 
                                          v-model='model_parameter.effort'
                                          :items='reasoning_list' 
                                          item-text='name' 
                                          item-value='id' 
                                          :readonly='!isEdit' 
                                          :class='!isEdit ? "remove-arrow" : ""')
                                            template(v-slot:append-outer)
                                              v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                              v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                              v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                              v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                    v-col.pr-md-4(cols='12' md='12' :title='aibotData.description').my-1
                                          .d-flex.align-center.justify-md-space-between
                                            h6 {{$t('CONTACT_DETAIL.DESCRIPTION')}} :
                                            div
                                              v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                              v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                              v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                              v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                          p.d-flex.align-start.input-has-label
                                            //- label {{$t('CONTACT_DETAIL.DESCRIPTION')}}
                                            v-textarea.span.textarea-style(v-model='aibotData.description' :readonly='!isEdit' solo no-resize rows='2')
                                              template(v-slot:append)
            //-  在channel不是UpSide 或 UpGPT_Portal狀況下顯示                      
            v-col.pr-0(v-else cols='6')
              v-card.deal-tab-card.rounded-card(style='width:98.5%;' flat min-height='300px')
                v-row(no-gutters='no-gutters' align="center" justify="start")
                  v-col(cols='12' md='12')
                      .pt-6.pb-3
                        v-card-text.mt-0.pa-0
                          h4.f-text-highlight-word.ml-6 {{$t("ADD_AIBOTS.DETAIL")}}
                          v-row.pl-3
                            v-col(cols='3').pr-0.pl-0
                              .d-flex.align-start.justify-center.bot-icon.pt-2
                                //- v-badge(bordered  avatar color="white" offset-x="13" offset-y="67")
                                //-   template(v-slot:badge)
                                //-     v-avatar()
                                //-       v-img(v-if='select_inbox.channel == "teams"' src='@/assets/images/teams_logo.png' width='25px')
                                //-       v-icon(v-else :color='get_upchat_channel_icon(select_inbox.channel).color' size='23') {{get_upchat_channel_icon(select_inbox.channel).icon}}
                                div(style='border: #14c6de solid 5px;border-radius:50%;min-width:120px;height:120px;').d-flex.justify-center.align-center
                                  v-img(src="../assets/images/botsetting.png"   max-width="85px")
                            v-col(cols='9')
                              div.d-flex.justify-end.pr-3
                                  v-btn(fab :icon='!aibotData.active' :color='aibotData.active? "#5fe98b":"#6c757d"' @click='openAibot()' width='24' height='24' :ripple='false'  depressed dark :title='$t("ADD_AIBOTS.ONOFF")')
                                    v-icon(size='21' style='padding-top:1px;') mdi-power
                                  v-btn.ml-2( icon  @click='onDelete()' width='24' height='24' :ripple='false'  depressed dark :title='$t("GENERAL.DELETE")')
                                    v-icon(size='16' color='#6c757d') icon-remove
                              //- .scrollbar.MeetingRecapMinH_ChatBot  
                              v-form.pt-2(v-model='valid' ref='formContact')
                                v-row(no-gutters)
                                  v-col.pr-md-4(cols='12' md='12').my-1.mb-1
                                    p.d-flex.align-center.input-has-label.input-has-label-no-border.position-relative
                                      label.pt-3
                                        h6.t-black {{$t('ADD_AIBOTS.NAME')}} :
                                      v-text-field.v-text-field_low_z-index(solo falt dense v-model='aibotData.bot_name' :readonly='!isEdit' ref='firstTextField' :rules="formRule.rules100" style='padding-top:0.1rem;') 
                                          template(v-slot:append)
                                              v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                              v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                              v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                              v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                  v-col.pr-md-4(cols='12' md='12').mb-3
                                    p.d-flex.align-center.input-has-label.input-has-label-no-border
                                      label.pt-3
                                        h6.t-black {{$t('ADD_AIBOTS.INBOX')}} :
                                      v-autocomplete(
                                          solo flat dense
                                          v-model='select_inbox' 
                                          :rules='formRule.nameRules', 
                                          :items='inbox_list' 
                                          item-text='name' 
                                          item-value='id'  
                                          return-object
                                          :menu-props='{closeOnClick:true}'
                                          :readonly='!isEdit'
                                          style='padding-top:0.1rem;'
                                          :class='!isEdit ? "remove-arrow" : ""'
                                        )
                                          template(v-slot:selection="data")
                                              .d-flex.justify-space-between
                                                v-img(v-if='data.item.channel == "teams"' src='@/assets/images/teams_logo.png' width='25px')
                                                v-icon(v-else :color='get_upchat_channel_icon(data.item.channel).color') {{get_upchat_channel_icon(data.item.channel).icon}}
                                                v-list-item-title.pl-1.pt-1(v-html="data.item.name")
                                          template(v-slot:item="data")
                                            v-img(v-if='data.item.channel == "teams"' src='@/assets/images/teams_logo.png' width='25px')
                                            v-icon(v-else :color='get_upchat_channel_icon(data.item.channel).color') {{get_upchat_channel_icon(data.item.channel).icon}}
                                            v-list-item-title.pl-4(v-html="data.item.name")
                                          template(v-slot:append-outer)
                                              v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                              v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                              v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                              v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                  v-col.pr-md-4(cols='12' md='12').mb-3            
                                    p.d-flex.align-center.input-has-label.input-has-label-no-border
                                        label.pt-2
                                          h6.t-black {{$t('GPT_AIBOTS.REPLY_LANGUAGE')}} :
                                        v-select.no-border( solo flat dense
                                        v-model='aibotData.answer_language'
                                        :items='assistant_language_list' 
                                        item-text='name' 
                                        item-value='key'
                                        :readonly='!isEdit'
                                        :class='!isEdit ? "remove-arrow" : ""'
                                        )
                                          template(v-slot:append-outer)
                                            v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                            v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                            v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                            v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                  v-col.pr-md-4(cols='12' md='12').mb-3            
                                    p.d-flex.align-center.input-has-label.input-has-label-no-border
                                        label.pt-2
                                          h6.t-black {{$t('GPT_AIBOTS.MODEL')}} :
                                        v-select.no-border( solo flat dense 
                                        v-model='aibotData.deployment_name'
                                        :items='model_list' 
                                        item-text='name' 
                                        item-value='id' 
                                        :readonly='!isEdit' 
                                        :class='!isEdit ? "remove-arrow" : ""')
                                          template(v-slot:append-outer)
                                            v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                            v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                            v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                            v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                  //- v-col.pr-md-4(cols='12' md='12' v-if="aibotData.deployment_name.includes('gpt5')")
                                  //-   p.d-flex.align-center.input-has-label.input-has-label-no-border
                                  //-       label.pt-2
                                  //-         h6.t-black {{$t('GPT_AIBOTS.VERBOSITY')}} :
                                  //-       v-select.no-border( solo flat 
                                  //-       v-model='model_parameter.verbosity'
                                  //-       :items='verbosity_list' 
                                  //-       item-text='name' 
                                  //-       item-value='id' 
                                  //-       :readonly='!isEdit' 
                                  //-       :class='!isEdit ? "remove-arrow" : ""')
                                  //-         template(v-slot:append-outer)
                                  //-           v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  //-           v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                  //-           v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  //-           v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                  //-   v-col.pr-md-4(cols='12' md='12' v-if="aibotData.deployment_name.includes('gpt5')")
                                  //-     p.d-flex.align-center.input-has-label.input-has-label-no-border
                                  //-         label.pt-2
                                  //-           h6.t-black {{$t('GPT_AIBOTS.REASONING_EFFORT')}} :
                                  //-         v-select.no-border( solo flat 
                                  //-         v-model='model_parameter.effort'
                                  //-         :items='reasoning_list' 
                                  //-         item-text='name' 
                                  //-         item-value='id' 
                                  //-         :readonly='!isEdit' 
                                  //-         :class='!isEdit ? "remove-arrow" : ""')
                                  //-           template(v-slot:append-outer)
                                  //-             v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  //-             v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                  //-             v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  //-             v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                  v-col.pr-md-4(cols='12' md='12' :title='aibotData.description').my-1
                                        .d-flex.align-center.justify-md-space-between
                                          h6 {{$t('CONTACT_DETAIL.DESCRIPTION')}} :
                                          div
                                            v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                            v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                            v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                            v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                                        p.d-flex.align-start.input-has-label
                                          //- label {{$t('CONTACT_DETAIL.DESCRIPTION')}}
                                          v-textarea.span.textarea-style(v-model='aibotData.description' :readonly='!isEdit' solo no-resize rows='2')
                                            template(v-slot:append)
            v-col(cols='6').pl-0
              v-card.deal-tab-card.rounded-card(style='width:99%; margin-left:6px;' flat min-height='300px')
                v-row.account-info(no-gutters='no-gutters' align="center" justify="start")
                  .pt-6.pb-3.mx-4
                    v-card-text.mt-0.pa-0
                        v-row()
                          v-col(cols='12' class).py-0
                            v-card-title.p-0
                              v-col(cols='1').px-0
                                v-img(src="../assets/images/book_big.png" class="white--text align-end"  width="100%")
                              v-col.py-0
                                h4.f-text-highlight-word.pt-3(style='margin-bottom:-2px;') {{$t('ADD_AIBOTS.BRAIN_SIZE')}}
                                div(style='margin-top:-10px;')
                                  span(class='small_word_gray ellipsis') {{$t('ADD_AIBOTS.M_1')}}
                          v-col(v-if='isAdmin' cols='12').mt-1
                            p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border.mb-2(v-if="aibotData.channel != 'UpGPT_Portal'")
                              label.mt-2
                                h6
                                  span.t-black {{$t('ADD_AIBOTS.KNOWLEDGE')}} :
                              v-autocomplete.no-border(flat dense  v-model='aibotData.knowledges' return-object multiple solo :readonly='!isEdit' :class='!isEdit ? "remove-arrow" : ""' :items='knowledgeList' item-text='name' item-value='id'  :menu-props='{closeOnClick:true}')
                                template(v-slot:append)
                                  v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                              v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                            v-row(no-gutters align="start" v-else)
                              // 左：Connect_to 文字
                              v-col(cols='2' md='2')
                                p.input-has-label.input-has-label-no-border.mb-0
                                  label.mt-2
                                    h6
                                      span.t-black {{$t('ADD_AIBOTS.CONNECT_TO')}} :
                              v-col(cols='8' md='8')
                                v-row(no-gutters)
                                  v-col(cols='12')
                                    v-radio-group.ma-0.mb-2(
                                      v-model="aibotData.selection_mode"
                                      row
                                      mandatory
                                      dense
                                      hide-details
                                      :disabled='!isEdit'
                                    )
                                      v-radio(:label='$t(\'KNOWLEDGE_FOLDER.library\')' value='knowledge_lib' color='#14C6DE')
                                      v-radio(v-if="folder_mode" :label='$t(\'KNOWLEDGE_FOLDER.folder\')' value='knowledge_folder' color='#14C6DE')

                                v-row(no-gutters)
                                  v-col(cols='12')
                                    // Knowledge: collapsed display + popup list on click
                                    div(v-if="aibotData.selection_mode === 'knowledge_lib'")
                                      v-menu(v-model="showKnowledgePopup" :close-on-content-click="false" offset-y min-width="320")
                                        template(v-slot:activator="{ on, attrs }")
                                          .knowledge-display(v-bind="attrs" v-on="on" style="min-height:36px; border:1px solid #eee; border-radius:6px; padding:4px 8px; display:flex; flex-wrap:wrap; align-items:center; gap:4px; cursor:pointer;")
                                            span(v-if="!aibotData.knowledges || aibotData.knowledges.length === 0" style="color:#aaa; font-size:14px;") {{$t("AGENT.BIND_LIB")}}
                                            .d-flex.align-center.mr-2(v-for="item in knowledgeList.filter(k => aibotData.knowledges.some(id => (id && id.id != null ? id.id : id) === k.id))" :key="item.id" style="flex-shrink:0;")
                                              v-avatar(size='16' :color='getColorFromKnowledgeName(item.name)' left class="mr-1")
                                                span(style='font-size:10px; color:#000;') {{item.name.slice(0,1)}}
                                              span(style='color:#444; font-size:13px;') {{item.name.split('@')[0]}}
                                        v-card
                                          v-list.py-0(flat style="max-height:220px; overflow:auto;")
                                            v-list-item-group(multiple)
                                              v-list-item(v-for="item in knowledgeList" :key="item.id" style="min-height:40px;")
                                                template(v-slot:default)
                                                  v-list-item-action.ma-0.mr-2
                                                    v-checkbox.ma-0(
                                                      v-model='aibotData.knowledges'
                                                      :value='item'
                                                      :disabled='!isEdit'
                                                      :value-comparator="(a, b) => (a && a.id != null ? a.id : a) === (b && b.id != null ? b.id : b)"
                                                      multiple
                                                      :color="checkbox_setting"
                                                    )
                                                  v-list-item-content.pa-0(style="display:inline;")
                                                    v-avatar(size='16' max-height='16' :color='getColorFromKnowledgeName(item.name)' left class="mr-2")
                                                      span(style='padding-bottom:1px; color:#000; font-size:10px;') {{item.name.slice(0,1)}}
                                                    span(style='color:#444; font-weight:400; font-size:14px;') {{item.name.split('@')[0]}}

                                    // Folder: collapsed display + popup treeselect on click
                                    div(v-else)
                                      v-menu(v-model="showFolderPopup" :close-on-content-click="false" offset-y min-width="320")
                                        template(v-slot:activator="{ on, attrs }")
                                          .knowledge-display(v-bind="attrs" v-on="on" style="min-height:36px; border:1px solid #eee; border-radius:6px; padding:4px 8px; display:flex; flex-wrap:wrap; align-items:center; gap:4px; cursor:pointer;")
                                            span(v-if="!selectedTreeIds || selectedTreeIds.length === 0" style="color:#aaa; font-size:14px;") {{$t("AGENT.BIND_FOLDER")}}
                                            .d-flex.align-center.mr-2(v-for="nodeId in selectedTreeIds" :key="nodeId" style="flex-shrink:0;")
                                              v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="16" max-width="16")
                                              span(style='color:#444; font-size:13px;') {{ nodeMap.get(nodeId) && nodeMap.get(nodeId).name || nodeId }}
                                        v-card
                                          div.kt-col--name(style="padding:8px;min-height:220px; min-width:280px; max-height:300px; overflow:auto;")
                                            treeselect(
                                              ref="kbTree"
                                              v-if="!loadingKnowledgeTree"
                                              v-model="selectedTreeIds"
                                              :options="folderOnlyTreeOptions"
                                              :normalizer="normalizer"
                                              :disable-branch-nodes="false"
                                              :always-open="true"
                                              :default-expand-level="0"
                                              noResultsText="No data available"
                                              :matchKeys="match_keys"
                                              :disableFuzzyMatching="true"
                                              :multiple="true"
                                              :disabled="!isEdit"
                                              :placeholder="$t('FOLDER_LOCATION_PICKER.PLACEHOLDER') || 'Select...'"
                                              @input="onTreeSelect"
                                            )
                                              template(v-slot:option-label="{ node }")
                                                .d-flex.align-center(:title="node.raw && node.raw.name")
                                                  v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="16" max-width="16")
                                                  span(style='color:#444; font-weight:400; font-size:14px;') {{ node.raw?.name || node.label }}

                                v-row(no-gutters)
                                  v-col(cols='12').pt-1.pb-2
                                    span.small_word_gray {{$t('ADD_AIBOTS.M_2')}}

                              // 右：icon template
                              v-col(cols='2' md='2').d-flex.align-start.justify-end.pt-2
                                template(v-if='isEdit && !loading')
                                  v-icon.mr-1(size='18' color='green' @click='confirmEditDetail()') icon-check
                                  v-icon(size='18' color='red' @click='cancelEditDetail()') mdi-window-close
                                v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit


                          v-col(cols='6' md='6' sm='12' v-if="(!memory_length_channel.includes(aibotData.channel)) || (tenant_name == 'libo' && aibotData.channel == 'teams')")
                            p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.MEMORY_LENGTH')}} :
                              v-select.no-border(
                                  solo flat 
                                  :class='!isEdit ? "remove-arrow" : ""'
                                  :items='memory_length_list' 
                                  v-model='aibotData.memory_length',
                                  :rules='formRule.nameRules', 
                                  required='required', 
                                  large='large'
                                  persistent-hint
                                  :readonly='!isEdit'
                                  dense
                              )
                                  template(v-slot:append-outer)
                                      v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                      v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                      v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                      v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col(cols='6' md='6' sm='12' v-if="aibotData.channel != 'UpSide'").py-0
                            p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.RETURN_KNOWLEDGE')}} :
                              v-select.no-border.mb-2(
                                  solo flat 
                                  :class='!isEdit ? "remove-arrow" : ""'
                                  :items='return_knowledge_list' 
                                  v-model='aibotData.return_knowledge',
                                  :rules='formRule.nameRules', 
                                  required='required', 
                                  large='large'
                                  persistent-hint
                                  :readonly='!isEdit'
                                  dense
                              )
                                  template(v-slot:append-outer)
                                      v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                      v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                      v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                      v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col(cols='12' style='margin-top:-25px;' v-if="(!memory_length_channel.includes(aibotData.channel)) || (tenant_name == 'libo' && aibotData.channel == 'teams')").pt-0
                            span(class='small_word_gray' ) {{$t('ADD_AIBOTS.M_3')}}
                          v-col(cols='6' md='6' sm='12' v-if="(!memory_length_channel.includes(aibotData.channel)) || (tenant_name == 'libo' && aibotData.channel == 'teams')")
                            p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.RETURN_LEN')}} :
                              v-select.no-border(
                                  solo flat
                                  :class='!isEdit ? "remove-arrow" : ""'
                                  :items='answer_length'
                                  v-model='aibotData.answer_length',
                                  required='required',
                                  item-text='text'
                                  item-value='value'
                                  large='large'
                                  persistent-hint
                                  :readonly='!isEdit'
                                  dense
                              )
                                  template(v-slot:append-outer)
                                      v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                      v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                      v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                      v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col(cols='6' md='6' sm='12' v-if="(!memory_length_channel.includes(aibotData.channel)) || (tenant_name == 'libo' && aibotData.channel == 'teams')")
                            p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.RETURN_TONE')}} :
                              v-select.no-border(
                                  solo flat
                                  :class='!isEdit ? "remove-arrow" : ""'
                                  :items='answer_tone'
                                  v-model='aibotData.answer_tone',
                                  required='required',
                                  item-text='text'
                                  item-value='value'
                                  large='large'
                                  persistent-hint
                                  :readonly='!isEdit'
                                  dense
                              )
                                  template(v-slot:append-outer)
                                      v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                      v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                      v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                      v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col(cols='6' md='6' sm='12' v-if="aibotData.channel != 'UpSide' && aibotData.channel != 'UpGPT_Portal'")
                            p.input-selection.ellipsis.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.AI_DISCLAIMER')}} :
                              v-checkbox.align-left-checkbox(v-model='aibotData.need_ai_disclaimer' :readonly='!isEdit' dense :hide-details='true')
                                template(v-slot:append)
                                  v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col.py-0(cols='6' md='6' sm='12' v-if="aibotData.channel != 'UpSide' && aibotData.channel != 'UpGPT_Portal'")
                            p.input-selection.ellipsis.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border     
                              label
                                h6.t-black {{$t('ADD_AIBOTS.RETURN_REPLY_WITH_IMAGE')}} :
                              v-checkbox.align-left-checkbox(v-model='aibotData.return_related_image_with_reply' :readonly='!isEdit' dense :hide-details='true')
                                template(v-slot:append)
                                  v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col.py-0(cols='6' md='6' sm='12' v-if="aibotData.channel != 'UpSide' && aibotData.channel != 'UpGPT_Portal'")
                            p.input-selection.ellipsis.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.CITATION')}} :
                              v-checkbox.align-left-checkbox(v-model='aibotData.need_citation' :readonly='!isEdit' dense :hide-details='true')
                                template(v-slot:append)
                                  v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col.py-0(cols='6' md='6' sm='12' v-if="aibotData.channel != 'UpSide' && aibotData.channel != 'UpGPT_Portal'")
                            p.input-selection.ellipsis.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.FILELINK')}} :
                              v-checkbox.align-left-checkbox(v-model='aibotData.need_file_link' :readonly='!isEdit' dense :hide-details='true')
                                template(v-slot:append)
                                  v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' @click='onEdit()') icon-edit
                          v-col.py-0(cols='6' md='6' sm='12' v-if="aibotData.channel == 'teams' && $store.state.vectorBackend !== 'milvus'")
                            p.input-selection.ellipsis.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.IMAGE_SEARCH')}} :
                              v-checkbox.align-left-checkbox(v-model='aibotData.enable_image_search' :disabled='!can_image_search' :readonly='!isEdit' dense :hide-details='true')
                                template(v-slot:append v-if='can_image_search')                                  
                                  v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col.py-0(cols='6' md='6' sm='12' v-if="aibotData.channel == 'teams' && $store.state.vectorBackend !== 'milvus'")
                            p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.RETURN_IMAGE_QUANTITY')}} :  
                              v-select.no-border(solo flat
                                :class='!isEdit ? "remove-arrow" : ""'
                                :items='return_image_quantity'
                                v-model='aibotData.return_image',
                                persistent-hint
                                :readonly='!isEdit'
                                :disabled='!can_image_search'
                              )
                                template(v-slot:append-outer v-if='can_image_search')
                                  v-icon.pt-1.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col.py-0(cols='6' md='6' sm='12' v-if="aibotData.channel != 'UpSide'")
                            p.input-selection.ellipsis.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.SHOW_ALL_IMAGE')}} :
                              v-checkbox.align-left-checkbox(v-model='aibotData.show_all_image' :readonly='!isEdit' dense :hide-details='true')
                                template(v-slot:append v-if="")
                                  v-icon.pt-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col.py-0(cols='6' md='6' sm='12' v-if="aibotData.channel == 'UpGPT_Portal'")
                            p.input-selection.ellipsis.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.SHOW_PRIVATE_KNOWLEDGE')}} :
                              v-checkbox.align-left-checkbox(v-model='private_knowledge' :readonly='!isEdit' dense :hide-details='true')
                                template(v-slot:append v-if="")
                                  v-icon.pt-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit

                          v-col.py-0(cols='6' md='6' sm='12' v-if="aibotData.channel == 'UpGPT_Portal' && $store.state.webSearchEnabled")
                            p.input-selection.ellipsis.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.WEB_SEARCH_TOGGLE')}} :
                              v-checkbox.align-left-checkbox(v-model='web_search_pref' :readonly='!isEdit' dense :hide-details='true')
                                template(v-slot:append v-if="")
                                  v-icon.pt-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                          v-col.py-0(cols='6' md='6' sm='12' v-if="aibotData.channel == 'UpGPT_Portal'")
                            p.input-selection.ellipsis.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border
                              label
                                h6.t-black {{$t('ADD_AIBOTS.HIDE_ANSWER_WITHOUT_REFERENCE')}} :
                              v-checkbox.align-left-checkbox(v-model='aibotData.hide_ans_without_ref' :readonly='!isEdit' dense :hide-details='true')
                                template(v-slot:append v-if="")
                                  v-icon.pt-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                  v-icon.pt-1(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                                  v-progress-circular.pt-1(size='18' v-if='loading' indeterminate color='primary')
                                  v-icon.pt-1(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit

      // 權限設定區
      #page-inner.pa-3.pb-6.d-flex.justify-center(v-if="!loading && aibotData.channel.toUpperCase() != 'API'")
        instancePermissionCard(:instance_id='target_id', model_type='BOT')
      #page-inner.pa-3.d-flex.align-start.justify-start.pl-13.pt-0(style='width:97%;')
        v-row(no-gutters='no-gutters' align="center" justify="center" style='padding-top:0.3%;')
            v-col(cols='12' md='12')
                v-card.deal-tab-card.rounded-card(flat)
                  v-row(no-gutters='no-gutters' align="center" justify="start")
                    v-col(cols='12' md='12')
                        v-card-title.pa-0.pt-1.d-flex.align-center.justify-md-space-between
                          div.pa-2.d-flex.align-center(width="30px")
                            div.pl-5.pt-3
                              h4.f-text-highlight-word(style='margin-bottom:-10px;') {{$t("ADD_AIBOTS.C_SETTING")}}
                              span(class='small_word_gray ellipsis' ) {{$t('ADD_AIBOTS.M_4')}}
                        v-card-text.pb-8
                          v-row
                              v-col(cols='3')
                                p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border.mb-2
                                  label.pt-3
                                    h6.t-black {{$t('GPT_AIBOTS.AIASSISTANTNAME')}} :
                                  v-text-field(solo falt dense persistent-hint :hint=`$t('ADD_AIBOTS.M_8')` v-model='aibotData.assistant_name' :readonly='!isEdit' ref='firstTextField' :rules="formRule.rules100" style='padding-top:0.1rem;') 
                                      template(v-slot:append v-if="aibotData.channel != 'UpSide'")
                                          v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                          v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                          v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                          v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                              v-col(cols='3')
                                p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border.mb-2
                                  label.pt-3
                                    h6.t-black {{$t('ADD_AIBOTS.ROLE')}} :
                                  v-text-field(solo falt dense persistent-hint :hint=`$t('ADD_AIBOTS.M_5')` v-model='aibotData.assistant_role' :readonly='!isEdit' ref='firstTextField' :rules="formRule.rules500" style='padding-top:0.1rem;') 
                                      template(v-slot:append v-if="aibotData.channel != 'UpSide'")
                                          v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                          v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                          v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                          v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                              v-col(cols='3')
                                p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border.mb-2
                                  label.pt-3
                                    h6.t-black {{$t('ADD_AIBOTS.SCOPE')}} :
                                  v-text-field(solo falt dense persistent-hint :hint=`$t('ADD_AIBOTS.M_6')` v-model='aibotData.conversation_topic_limit' :readonly='!isEdit' ref='firstTextField' :rules="formRule.rules500" style='padding-top:0.1rem;') 
                                      template(v-slot:append v-if="aibotData.channel != 'UpSide'")
                                          v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                          v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                          v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                          v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
                              v-col(cols='3')
                                p.d-flex.align-center.justify-md-space-between.position-relative.input-has-label.input-has-label-no-border.mb-2
                                  label.pt-2
                                    h6.t-black {{$t('ADD_AIBOTS.TOPIC')}} :
                                  v-text-field(solo falt dense persistent-hint :hint=`$t('ADD_AIBOTS.M_7')` v-model='aibotData.conversation_topic' :readonly='!isEdit' ref='firstTextField' :rules="formRule.rules500" style='padding-top:0.1rem;') 
                                      template(v-slot:append v-if="aibotData.channel != 'UpSide'")
                                          v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                                          v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close  
                                          v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                                          v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit

    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
</template>

<script>
import loadingOverlay from "@/components/Common/loadingOverlay";
import messageDialog from "@/components/Dialog/messageDialog";
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import i18n from '/common/plugins/vue-i18n.js';
import KnowledgeLibraryService from "../services/KnowledgeLibraryService";
import AiBotsService from "../services/AiBotsService";
import AssistantLanguageList from "@/array/the_assistant_languageList";
import GPTModelList from "@/array/the_gpt_modelList";
import GPTModelListForUpside from "@/array/the_gpt_modelList_for_upside";
import GPTModelParameterList from "@/array/the_gpt_modelParameterList";
import instancePermissionCard from "../components/GPT_Common/instancePermissionCard.vue";
import PreferenceService from "../services/PreferenceService";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import knowledge_color_group from "@/array/the_knowledgeColorGroup";
export default {
  components: {
    loadingOverlay,
    messageDialog,
    successDialog,
    errorDialog,
    instancePermissionCard,
    Treeselect,
  },
  data() {
    return {
      // other
      valid:true,
      isEdit:false,
      loading:false,
      delLoading:false,
      breadcrumbs: [{
        text: i18n.t('GPT_MENU.BACKTO') + i18n.t('GPT_AIBOTS.TITLE'),
        disabled: false,
        href: '/upgpt/Chatbot',
      }],
      formRule: {
        nameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')
        ],
        rules100: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,100}$/.test(v) || i18n.t('RULE.RULE_100'),
        ],
        rules500: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,500}$/.test(v) || i18n.t('RULE.RULE_500'),
        ],
      },
      // Dialog
      messageDialog: false,
      message: "",
      successDialog: false,
      successMessage: "",
      errorDialog: false,
      errorMessage: "",
      // Data
      aibotData:null,
      originAiBotData:null,
      chatBotList:[],
      knowledgeList:[],
      return_knowledge_list:[],
      memory_length_list:[],
      return_image_quantity: [],
      chatBotName:"",
      target_id : this.$route.params.id,
      mode: null,
      inbox_list:[],
      select_inbox:null,
      assistant_language_list: AssistantLanguageList,
      model_list : GPTModelList,
      model_list_for_upside : GPTModelListForUpside,
      model_parameter_list: GPTModelParameterList,
      verbosity_list: GPTModelParameterList['verbosity'],
      reasoning_list: GPTModelParameterList['reasoning_effort'],
      model_parameter: {
        verbosity:'low',
        effort: 'minimal'
      },
      can_image_search:false,
      folder_mode: true,
      answer_tone:[
      { text: this.$t('TONE_LEVEL.PROFESSIONAL'), value: "Professional" },
      { text: this.$t('TONE_LEVEL.FRIENDLY'), value: "Friendly" },
      { text: this.$t('TONE_LEVEL.CASUAL'), value: "Casual" },
      { text: this.$t('TONE_LEVEL.INSPIRING'), value: "Inspiring" },
      { text: this.$t('TONE_LEVEL.PASSIONATE'), value: "Passionate" },
      { text: this.$t('TONE_LEVEL.WARM'), value: "Warm" }
      ],
      answer_length: [
      { text: this.$t('DETAIL_LEVEL.DETAILED'), value: "Long" },
      { text: this.$t('DETAIL_LEVEL.NORMAL'), value: "Detailed" },
      { text: this.$t('DETAIL_LEVEL.CONCISE'), value: "Short" },
      ],
      company_logo_image: null,
      company_logo_photo: "",
      isCompany_Logo_Photo: false,
      isAdmin: false,
      private_knowledge: 1,
      web_search_pref: true,
      gpt5_channel:['UpGPT_Portal','teams'],
      memory_length_channel:['UpSide','UpGPT_Portal','teams'],
      tenant_name: window.localStorage.getItem('tenant'),
      allKnowledgeColor:[],
      showKnowledgePopup: false,
      showFolderPopup: false,
      selectedTreeIds: [],
      treeOptions: [],
      loadingKnowledgeTree: false,
      nodeMap: new Map(),
      match_keys: ["path", "id"],
      originSelectedTreeIds: [],
      checkbox_setting: document.documentElement.style.getPropertyValue('--checkbox_setting') || '#14C6DE',
      // tenant_name: "libo" // libo tenant test only
    };
  },
  computed:{
    removeAutoAssistantLanguageList(){
      let newList = [...this.assistant_language_list];
      let removeAutoLanguageList=newList.filter(item => item.key !== 'auto')
      return removeAutoLanguageList;
    },
    folderOnlyTreeOptions() {
      const filterFolders = (nodes) => {
        if (!Array.isArray(nodes)) return [];
        return nodes.map(node => {
          if (!node || node.type === 'library' || node.raw?.type === 'library') return null;
          const filteredChildren = filterFolders(node.children);
          return { ...node, children: filteredChildren };
        }).filter(Boolean);
      };
      return filterFolders(this.treeOptions);
    },
  },
  async created() {
    this.loading = true;
    this.checkAdmin();
    for(let i = 1; i<11;i++){
      if(i<=3){
        this.memory_length_list.push(i);
      }
      if(i>=3){
        this.return_knowledge_list.push(i);
      }
    }
    for(let i = 1; i<=30;i++){
      this.return_image_quantity.push(i);
    }
    await this.get_upchat_inbox();
    await this.getKnowledgeList();
    await this.getDetailData();
    this.get_upgpt_setting();
    await this.get_private_knowledge()
    await this.get_web_search_pref()
    this.getAnswerLen_Tone();
    await this.loadKnowledgeTree();
    await this.defaultColorKnowledgeList();
    this.set_selected_tree();
    AiBotsService.getAvailableDeployments().then(res => {
      if (this.gpt5_channel.includes(this.aibotData.channel) && !(this.aibotData.channel == 'teams' && this.tenant_name == 'libo')) {
        this.model_list = this.model_list.concat(res.data)
        this.model_list_for_upside = this.model_list_for_upside.concat(res.data)
      }
    })
    this.loading = false;
  },
  destroyed() {
  },
  methods: {
    checkAdmin(){
      let userJson = window.localStorage.getItem('user');
      let user = JSON.parse(userJson);
      user.is_staff ? this.isAdmin = true : this.isAdmin = false;
    },
    async get_upgpt_setting(){
        let setting = await this.upgpt_image_func_setting();
        this.can_image_search = setting['can_image_search'];
        this.folder_mode = setting['knowledge_folder'];
    },
    set_title(){
        const title = localStorage.getItem('title');
        let title_name = this.aibotData.bot_name;
        let tab_name = '';
        tab_name = this.aibotData.bot_name;
        document.title = title+' : '+title_name +' – UpGPT';
        return tab_name;
    },
    async getDetailData(){
      await AiBotsService.detail(this.target_id).then((response)=>{
          let data = response.data;
          data.knowledges = data.linked_bots_and_knowledge_set.map(item=> {return item.knowledge_lib_id});
          data.knowledges_count = data.linked_bots_and_knowledge_set.length;
          data.folders = data.linked_bots_and_knowledge_folder_set.map(item=> {
            return item.knowledge_folder;
          });
          this.aibotData = response.data;
          if (this.gpt5_channel.includes(this.aibotData.channel) && !(this.aibotData.channel == 'teams' && this.tenant_name == 'libo')) {
            let gpt5_series = [
              {name:"GPT 5",id:"gpt5"},
              {name:"GPT 5 mini",id:"gpt5-mini"},
              {name:"GPT 5 nano",id:"gpt5-nano"},
              {name:"GPT 5.1",id:"gpt51"},
              // {name:"GPT 5.1 chat",id:"gpt51-chat"}
              {name:"GPT 5.2",id:"gpt52"},
              {name:"GPT 5.4",id:"gpt54"},
              {name:"GPT-5.4 mini",id:"gpt54-mini"},
              {name:"GPT-5.4 nano",id:"gpt54-nano"}
            ]
            this.model_list = this.model_list.concat(gpt5_series)
          }
          if(data.model_parameter[data.deployment_name]){
            this.model_parameter = data.model_parameter[data.deployment_name];
          }
          if(this.aibotData.company_logo_photo != null){
            this.isCompany_Logo_Photo = true;
            this.company_logo_photo = this.aibotData.company_logo_photo;
          }
          this.select_inbox = this.inbox_list.filter(el=>el.id == this.aibotData.inbox_id)[0];
          this.set_title();
      }).catch(response => {
          // Redirect to PermissionError page if error status is 403
          if (response.response.status == 403)
          {
              this.$router.replace('/upgpt/PermissionError');
          }
          else if(response.response.status == 404)
          {
              this.$router.replace('/upgpt/PageNotFound');
          }
      });
    },
    async uploadimage(event){
      if (event != null) {
        // file type
        let n = event.type.indexOf("image");
        if (n == -1) {
          this.showErrorDialog(i18n.t('GPT_AIBOTS.IMG_ERROR'));
        } else {
        // photo size
          if (event.size > 5242880) {
            this.showErrorDialog(i18n.t('GPT_AIBOTS.IMG_ERROR_2'));
          } else {
            await AiBotsService.company_logo_photo(this.target_id, this.company_logo_image)
            .then(response => { 
              this.isCompany_Logo_Photo = true;              
              this.company_logo_photo = response.data.company_logo_photo;                       
            });
          }
        }
      }       
    },
    changephoto(){
      this.$refs.uploader.$refs.input.click()
    },
    async get_upchat_inbox(){
      await AiBotsService.get_upchat_inbox().then((response)=>{
        this.inbox_list = [];
        let used = new Set(response.data.used);
        let upchat = response.data.upchat.payload.map(el=>{return {"id":el.id,"name":el.name,"channel":this.get_upchat_channel(el.channel_type),"disabled":used.has(el.id.toString())}});
        let teams = response.data.teams;
        if(teams.length > 0){
          for(let teams_item in teams){
            teams[teams_item].disabled = used.has(teams[teams_item].id);
            if(teams[teams_item].name == "teams"){
              teams[teams_item].name = "Teams";
            }
          }
        }
        this.inbox_list.push({ header: 'UpChat'});
        this.inbox_list = this.inbox_list.concat(upchat);
        this.inbox_list.push({ divider: true });
        this.inbox_list.push({ header: 'Teams'});
        this.inbox_list = this.inbox_list.concat(teams);
      })
    },
    get_upchat_channel(data){
        let channel_str = data.toLowerCase()
        let channel_name = ''
        switch(true){
            case channel_str.includes('facebook'):
                return "Facebook"
            case channel_str.includes('line'):
                return "Line"
            case channel_str.includes('webchat'):
                return "Webchat"
            case channel_str.includes('whatsapp'):
                return "WhatsApp"
            case channel_str.includes('sms'):
                return "SMS"
            case channel_str.includes('mail'):
                return "Mail"
            default:
                if(data.split('::').length>1){
                    channel_name = data.split('::')[1];
                }else{
                    channel_name = 'Web';
                }
                return channel_name
        }
    },
    get_upchat_channel_icon(data){
        let channel_str = data.toLowerCase()
        switch(true){
            case channel_str.includes('facebook'):
                return {icon:'mdi-facebook',color:'blue'}
            case channel_str.includes('line'):
                return {icon:'fab fa-line',color:'green'}
            case channel_str.includes('webchat'):
                return {icon:'mdi-earth',color:'blue'}
            case channel_str.includes('whatsapp'):
                return {icon:'mdi-whatsapp',color:'green'}
            case channel_str.includes('sms'):
                return {icon:'mdi-message-text-outline',color:'blue'}
            case channel_str.includes('mail'):
                return {icon:'mdi-email',color:'blue'}
            default:
                return {icon:'mdi-earth',color:'blue'}
        }
    },
    getknowledgeName(){
      let names = this.aibotData.knowledges.map(el=>{return el.name}).join();
      return names
    },
    async getBotList(){
      await AiBotsService.select_list().then((response)=>{
        this.chatBotList = response.data;
      })
    },
    async getKnowledgeList(){
      await KnowledgeLibraryService.select_list().then((response)=>{
        this.knowledgeList = response.data;
      })
    },
    async openKnowledge(data){
      let edit_data = {
        "id" : data.id,
        "active" : !data.active
      }
      await KnowledgeLibraryService.edit(edit_data).then((response)=>{
        data.active = response.data.active;
      })
    },
    async openAibot(){
      let edit_data = {
        "id" :this.target_id,
        "active" : !this.aibotData.active
      }
      this.aibotData.active = !this.aibotData.active;
      await AiBotsService.active(this.target_id,edit_data).then((response)=>{
        this.aibotData.active = response.data.active;
      })
    },
    onDelete(){
      this.mode = "delete";
      this.message = i18n.t("ADD_AIBOTS.DEL_MSG");
      this.messageDialog = true;
    },
    getFormatTime(data){
        let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',hour: '2-digit',minute: '2-digit',hour12: false };
        let today  = new Date(data);
        if(this.$i18n.locale == "zh_TW")
        {
            return today.toLocaleDateString("zh-TW", options); 
        }else
        {
            return today.toLocaleDateString("en-US", options);
        }
    },
    onEdit(){
        this.isEdit = true;
        this.originAiBotData = JSON.parse(JSON.stringify(this.aibotData));
        this.originSelectedTreeIds = [...this.selectedTreeIds];
    },
    async confirmEditDetail(){
      let edit_data = JSON.parse(JSON.stringify(this.aibotData));
      if(edit_data.bot_name == 'UpSide' && this.select_inbox == undefined){
        edit_data.inbox_id = 'UpSide'
        edit_data.channel = 'UpSide'

        edit_data.need_ai_disclaimer = true;
        edit_data.citation = true;
        edit_data.return_related_image_with_reply = true;
      }else if(edit_data.channel == 'UpGPT_Portal' && this.select_inbox == undefined){
        edit_data.inbox_id = 'UpGPT_Portal_Default'
        edit_data.channel = 'UpGPT_Portal'

        edit_data.need_ai_disclaimer = true;
        edit_data.citation = true;
        edit_data.return_related_image_with_reply = true;
      }else{
        edit_data.inbox_id = this.select_inbox.id;
        edit_data.channel = this.select_inbox.channel;
      }
      if(edit_data.channel != 'teams'){
        edit_data.enable_image_search = false;
        edit_data.return_image = 1;
      }
      if(edit_data.channel == "UpGPT_Portal"){
          let update_private_knowledge = 0
          if (this.private_knowledge){
              update_private_knowledge = 1
          }
          await PreferenceService.update("PRIVATE_KNOWLEDGE", update_private_knowledge);
          await PreferenceService.updateWebSearch(this.web_search_pref ? "True" : "False");
      }
      edit_data.model_parameter = this.model_parameter;
      edit_data.linked_bots_and_knowledge_set = [];
      edit_data.linked_bots_and_knowledge_folder_set = [];
      console.log("Edit Data ",edit_data)
      await AiBotsService.edit(this.target_id,edit_data).then((response)=>{
          if(response.data == "Has agent bot"){
            this.showErrorDialog(i18n.t('GPT_AIBOTS.HAS_LINKED_BOT'));
            this.addBtn_loading = false;
          }else if(response.data == "No agent bot"){
            this.showErrorDialog(i18n.t('GPT_AIBOTS.NO_EXIST_BOT'));
            this.addBtn_loading = false;
          }else{
            let data = response.data;
            data.knowledges = data.linked_bots_and_knowledge_set.map(item=> {return item.knowledge_lib_id});
            data.knowledges_count = data.linked_bots_and_knowledge_set.length;
            data.folders = data.linked_bots_and_knowledge_folder_set.map(item=> {
              return item.knowledge_folder;
            });
            this.selectedTreeIds = data.linked_bots_and_knowledge_folder_set.map(item=> {
              const f = item.knowledge_folder;
              return (f && f.id != null) ? f.id : f;
            });
            this.aibotData = response.data;
            this.buildNodeMap(this.treeOptions);
            this.select_inbox = this.inbox_list.filter(el=>el.id == this.aibotData.inbox_id)[0];
            this.isEdit = false;
            if(data.model_parameter[data.deployment_name]){
              this.model_parameter = data.model_parameter[data.deployment_name];
            }
          }
          if(this.originAiBotData.inbox_id != this.aibotData.inbox_id){
            this.get_upchat_inbox();
          }
      })
    },
    cancelEditDetail(){
      this.isEdit = false;
      this.aibotData = this.originAiBotData;
      this.selectedTreeIds = [...(this.originSelectedTreeIds || [])];
    },
    onMail: function (mail) {
      return "mailto:" + mail;
    },
    // Dialog Area ----------------------------------------- [Start]
    showSuccessDialog() {
      this.successDialog = true;
    },
    onEmitSuccessDialog() {
      this.successDialog = false;
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
      if(this.mode == 'delete'){
        this.mode = null;
        this.$router.push('/upgpt/Chatbot');
      }
    },
    showMessageDialog(message) {
      this.messageDialog = true;
      this.message = message;
    },
    async onEmitMessageDialog(val) {
      if(val){
        this.delLoading = true;
        this.messageDialog = false;
        if(this.mode == "delete"){
          await AiBotsService.delete(this.target_id).then(()=>{
            this.$router.push('/upgpt/Chatbot');
            this.delLoading = false;
            this.mode = null;
          }).catch(() => {
              this.showErrorDialog(i18n.t('GPT_KNOWLEDGE.DELETE_ERROR'));
          });
        }
      }
      this.messageDialog = false;
    },
    async reFresh(){
      this.loading = true;
      await this.getDetailData();
      this.loading = false;
    },
    getAnswerLen_Tone() {
      this.answer_length = [
      { text: this.$t('DETAIL_LEVEL.DETAILED'), value: "Long" },
      { text: this.$t('DETAIL_LEVEL.NORMAL'), value: "Detailed" },
      { text: this.$t('DETAIL_LEVEL.CONCISE'), value: "Short" },
      ];
      this.answer_tone = [
      { text: this.$t('TONE_LEVEL.PROFESSIONAL'), value: "Professional" },
      { text: this.$t('TONE_LEVEL.FRIENDLY'), value: "Friendly" },
      { text: this.$t('TONE_LEVEL.CASUAL'), value: "Casual" },
      { text: this.$t('TONE_LEVEL.INSPIRING'), value: "Inspiring" },
      { text: this.$t('TONE_LEVEL.PASSIONATE'), value: "Passionate" },
      { text: this.$t('TONE_LEVEL.WARM'), value: "Warm" }
      ];
    },
    async get_private_knowledge(){
       await PreferenceService.getPrivateKnowledge().then((response) => {
            this.private_knowledge = (response.data === '') ? 1 : response.data;
       });
    },
    async get_web_search_pref(){
        await PreferenceService.getWebSearch().then((response) => {
            this.web_search_pref = response.data !== "False";
        });
    },
    normalizer(raw) {
        const id = raw.id;
        const name = raw.name ?? raw.system_name ?? String(raw.id);
        const node = { id, label: name, name, raw, path: raw.path, type: raw.type };
        this.nodeMap.set(id, node);
        return node;
    },
    applyFullPaths(nodes, parentPath = "/") {
        if (!Array.isArray(nodes)) return nodes;
        const normalizedParent = (parentPath || "/").replace(/\/+$/g, "") || "/";
        const base = normalizedParent === "/" ? "" : normalizedParent;
        nodes.forEach(node => {
            if (!node) return;
            const segment = node.name ?? node.system_name ?? String(node.id ?? "");
            const currentPath = `${base}/${segment}`.replace(/\/+/g, "/");
            node.path = currentPath;
            if (Array.isArray(node.children) && node.children.length) {
                this.applyFullPaths(node.children, currentPath);
            }
        });
        return nodes;
    },
    checkCanView(nodes) {
      if (!Array.isArray(nodes)) return [];
      return nodes.map(node => {
          const filteredChildren = node.children?this.checkCanView(node.children):[];
          const canViewSelf = node.perm.can_view === true;
          // 只要自己能看 或 子層還有東西 → 保留
          if (canViewSelf || filteredChildren.length > 0) {
              return {
                  ...node,
                  children: filteredChildren
              };
          }
          // 否則砍掉
          return null;
      }).filter(Boolean);
    },
    onTreeSelect(val) {
      this.selectedTreeIds = val || [];
      if (!val || val.length === 0) {
        this.aibotData.folders = [];
        return;
      }
      // 多選 folder：合併所有 folder 底下 libraries
      const allItems = [];
      val.forEach(id => {
        const node = this.nodeMap.get(id);
        if (node) allItems.push(node);
      });
      // 全域去重
      const seen = new Set();
      const merged = allItems.filter((item) => {
        const folderId = item?.id;
        if (!folderId || seen.has(folderId)) return false;
        seen.add(folderId);
        return true;
      });

      // 新格式：給後端
      this.aibotData.folders = merged.map((n) => ({
          id: n.id,
      }));
    },

    async loadKnowledgeTree() {
        this.loadingKnowledgeTree = true;
        try {
            const response = await KnowledgeLibraryService.getFolderTree();
            let tree = response.data?.tree || [];
            tree = this.checkCanView(tree);
            tree = this.applyFullPaths(tree);
            this.treeOptions = tree;
            this.buildNodeMap(tree);
        } finally {
          this.loadingKnowledgeTree = false;
        }
    },
    buildNodeMap(nodes) {
      if (!Array.isArray(nodes)) return;
      nodes.forEach(node => {
        if (!node) return;
        const id = node.id;
        const name = node.name ?? node.system_name ?? String(id);
        this.nodeMap.set(id, { id, label: name, name, raw: node, path: node.path, type: node.type });
        if (Array.isArray(node.children) && node.children.length) {
          this.buildNodeMap(node.children);  // 遞迴處理子節點
        }
      });
    },
    getColorFromKnowledgeName(knowledge_name){
      let color_data = this.allKnowledgeColor.find(item=>item.name == knowledge_name);
      return color_data ? color_data.color : 'aliceBlue';
    },
    async defaultColorKnowledgeList() {
      this.allKnowledgeColor = this.knowledgeList.map((item, index) => {
        item['color'] = knowledge_color_group[index]?.color || 'aliceBlue';
        return{
          id: item.id,
          name: item.name,
          color:item.color
        }
      });
    },
    set_selected_tree(){
      this.selectedTreeIds = this.aibotData.linked_bots_and_knowledge_folder_set.map(item=> {
        const f = item.knowledge_folder;
        return (f && f.id != null) ? f.id : f;
      });
    },
  },
  watch:{
    'aibotData.deployment_name'(newVal){
        // 切到一個 model_parameter 裡沒有的模型時，下面兩行會讀 undefined 的屬性
        // 而 TypeError。舊機器人的 model_parameter 不包含新增的模型，在收斂工具
        // 補值之前選新模型就會踩到，所以要先確認 key 存不存在。
        const parameter = (this.aibotData.model_parameter || {})[newVal];
        if(parameter){
            this.model_parameter.verbosity = parameter.verbosity;
            this.model_parameter.effort = parameter.effort;
        }
    }
  }
};
</script>
<style>
.company_logo_container{
  background-color: #f4f4f4;
  height: 50px !important;
  max-height: 50px;
  width: 8.5vw !important;
  max-width: 160px;
  border: 1px dashed #CCCCCC;
  border-radius: 5px !important;
}
.company_logo_container .v-image .v-image__image--cover{
 background-size: contain;
}
.company_logo_inner{
  background-color: #E8E8E8;
  height: 30px !important;
  max-height: 30px !important;
  width: 140px !important;
  max-width: 140px;
  border-radius: 5px !important;
  color: #999999;
  font-size: 16px !important;
  font-weight: 700 !important;
  font-family: 'Segoe UI', Tahoma, Verdana, sans-serif !important;
  font-style: normal !important;
}
.best-size-hint {
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  font-family: 'Segoe UI', Tahoma, Verdana, sans-serif;
  margin-top: -10px;
}
.kt-col--name .vue-treeselect--open .vue-treeselect__menu-container {
  position: static !important;
}
.kt-col--name .vue-treeselect__menu-container .vue-treeselect__menu {
  position: static !important;
  box-shadow: none !important;
  border: none !important;
  max-height: none !important;
  overflow-y: visible !important;
}
.kt-col--name .vue-treeselect__control {
  display: none !important;
}
.checkbox-grid-row .v-input--selection-controls__input {
  padding-bottom: 0 !important;
}
.align-left-checkbox.v-input--selection-controls.v-input {
  flex: 1 0 auto !important;
}

</style>